export const getCustomer = (state) => state.customer;
